import styled from 'styled-components/macro';
import { COLORS, TYPOGRAPHY } from 'styleguide';

const ErrorMessageButton = styled.p`
  margin-top: 0;
  margin-bottom: 16px;
  ${TYPOGRAPHY.body}
  color: ${COLORS.gray60};
  text-align: center;
`;

export default ErrorMessageButton;
